/**
 * UTILITAIRES POUR LA GESTION DES DOMAINES
 * Centralise toutes les fonctions réutilisables pour les domaines
 */


/**
 * Tronque la description à 20 mots maximum
 * @param {string} description - Description complète
 * @returns {string} Description tronquée
 */
export const getShortDescription = (description) => {
  if (!description) return "Aucune description";
  const words = description.split(" ");
  return words.length > 20 ? words.slice(0, 20).join(" ") + "..." : description;
};

/**
 * Gère les erreurs de chargement d'image
 * @param {Event} e - Événement d'erreur
 */
export const handleImageError = (e) => {
  e.target.onerror = null;
  e.target.src = "/assets/images/placeholder.png";
};

/**
 * Génère l'URL complète de l'image du domaine
 * @param {string} photo - Chemin de la photo
 * @returns {string} URL complète
 */
export const getDomainImageUrl = (photo) => {
  if (!photo) return "/assets/images/placeholder.png";
  return `${import.meta.env.VITE_API_BASE_URL}${photo}`;
};